import { useTranslations } from 'next-intl';
import { CaretUp } from 'assets/icons';
import CustomLink from 'components/shared/CustomLink';
import TableFAQ from 'components/shared/TableFAQ';
import styles from './FAQSection.module.css';

type FaqItem = {
  question: string;
  answer: string;
};

const getFaqItems = (t: (key: string) => string): FaqItem[] => [
  {
    question: t('photon.faqSection.items.howToUse.question'),
    answer: t('photon.faqSection.items.howToUse.answer'),
  },
  {
    question: t('photon.faqSection.items.holdDistance.question'),
    answer: t('photon.faqSection.items.holdDistance.answer'),
  },
  {
    question: t('photon.faqSection.items.results.question'),
    answer: t('photon.faqSection.items.results.answer'),
  },
  {
    question: t('photon.faqSection.items.wavelengths.question'),
    answer: t('photon.faqSection.items.wavelengths.answer'),
  },
  {
    question: t('photon.faqSection.items.protocols.question'),
    answer: t('photon.faqSection.items.protocols.answer'),
  },
  {
    question: t('photon.faqSection.items.warranty.question'),
    answer: t('photon.faqSection.items.warranty.answer'),
  },
  // {
  //   question: 'What certifications does Photon have?',
  //   answer: 'FCC, CE, UKCA, and RoHS.',
  // },
];

const FAQSection = () => {
  const t = useTranslations('photon');

  return (
    <div className={styles.paddingOverride}>
      <TableFAQ
        title={t('photon.faqSection.heading.stillQuestions')}
        faqItems={getFaqItems(t)}
        bgColor="black"
      />
      <div className={styles.seeAllRow}>
        <CustomLink href="/photon/faq">
          {t('photon.faqSection.text.seeAllFaqs')}{' '}
          <CaretUp
            style={{ transform: 'rotate(90deg)' }}
            width={14}
            height={14}
          />
        </CustomLink>
      </div>
    </div>
  );
};

export default FAQSection;
